<template>
  <div class="mobile-nav">
    <div
      :class="{ 'menu-open': open }"
      class="menu"
    >
      <v-list
        dense
        tag="nav"
      >
        <v-list-item
          v-for="(page, index) in menuPages"
          :key="index"
          :href="`/`+ page.slug"
          link
          :style="{ animationDuration: index * 0.15 + 's' }"
        >
          <v-list-item-content>
            <v-list-item-title class="menu-list">
              {{ page.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--
        <v-divider class="divider-sidebar" />
        
        <v-list-item
          v-for="item in ['login', 'register']"
          :key="item"
          :href="link.movie[item]"
          :style="{ animationDuration: navMenu.length * 0.15 + 's' }"
          link
        >
          <v-list-item-content>
            <v-list-item-title class="menu-list">
              {{ item }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->
      </v-list>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import './header-style';
</style>

<script>
import navMenu from './menu'
import link from '../../static/text/link'
import FremcastMenu from '@fremcast/section/Menu';

export default {
  extends: FremcastMenu,
  data() {
    return {
      link: link,
      navMenu: navMenu
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>
